module.exports = __webpack_public_path__ + "static/media/settings-darkmode.535f81e6.svg";